import React from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import RangoEdadForm from "./RangoEdadForm";

const RangoEdadEdit = () => {

  const navigate = useNavigate()

  const {id} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/rango-edad/' + id, {});

  const onUpdate = (rango) => {
    rango.id = id;
    axios.put(Apis.PROD + '/rango-edad/update/' + id, rango)
      .then(res => {
        successToast("Grupo etario actualizado correctamente")
        navigate('/rango-edad')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Grupos etarios' onClick={() => navigate('/rango-edad')}/>
        <PageTitle title={data.etapa}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <RangoEdadForm value={data} onSubmit={(rango) => onUpdate(rango)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default RangoEdadEdit;
